import { createTheme } from "@mui/material/styles";

/**
 * Thin adapter: MUI cannot parse var() in its palette (it runs alpha/darken on
 * these), so the values are read out of the CSS variables at runtime. tokens.css
 * stays the single source of truth — nothing here is hand-copied. Delete this
 * file with MUI.
 */
const read = (name, fallback = "") => {
  if (typeof document === "undefined") return fallback;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
};

// Tokens Tailwind needs as bare channels come back as "220 38 38".
const readColor = (name, fallback = "") => {
  const value = read(name, fallback);
  return /^[\d\s.]+$/.test(value) ? `rgb(${value})` : value;
};

export const createAppTheme = (mode = "light") =>
  createTheme({
    typography: {
      fontFamily: ["Manrope", "Plus Jakarta Sans", "sans-serif"].join(","),
    },
    palette: {
      mode,
      primary: {
        main: readColor("--color-brand"),
        light: readColor("--color-brand-light"),
        dark: readColor("--color-brand-hover"),
      },
      brand: {
        main: readColor("--color-brand"),
        light: readColor("--color-brand-light"),
        dark: readColor("--color-brand-dark"),
      },
      success: { main: readColor("--color-success") },
      error: { main: readColor("--color-danger") },
      warning: { main: readColor("--color-warning-text") },
      info: { main: readColor("--color-info-text") },
      background: {
        default: readColor("--color-ui-bg"),
        paper: readColor("--color-ui-surface"),
      },
      text: {
        primary: readColor("--color-ui-text"),
        secondary: readColor("--color-ui-text-muted"),
      },
      divider: readColor("--color-ui-border"),
    },
    components: {
      /* styleOverrides are emitted as raw CSS, so var() survives here. The
         palette above is a snapshot taken during render; this keeps inherited
         text on the live variable instead. */
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: "var(--color-ui-page)",
            color: "var(--color-ui-text)",
          },
        },
      },
      /* Paper backs Menu/Select/Autocomplete/Dialog popups. Component-level
         overrides (PaperProps, sx, className) still win over this default. */
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "var(--color-ui-surface)",
            color: "var(--color-ui-text)",
          },
        },
      },
    },
  });
